import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * True below the `md` breakpoint (< 900px) — the same line the old
 * "Best on Desktop" modal drew, so the phone layout and the sheet agree.
 *
 * VIEWPORT, never user agent: an iPad in landscape is a desktop, and the
 * crawler must get the same document as the reader (one URL, one HTML, the
 * layout chosen by width — ROADMAP "The phone branch").
 */
export function usePhoneViewport(): boolean {
  const theme = useTheme();
  // `noSsr`: read the query on the first render. Without it the hook returns
  // false for one frame, so a phone would paint the whole desktop shell and
  // then swap it out.
  return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
}
